module.exports = __webpack_public_path__ + "static/media/defaultAvatar21.e20582c4.svg";